function setUnsupportedMessage(){
    const translations = {
        pl: {
            h1: 'Niewspierana przeglądarka',
            content: `Ta przeglądarka nie jest wspierana w USOSweb.
            Aby korzystać z serwisu, pobierz aktualną wersję jednej z poniższych przeglądarek`
        },
        en: {
            h1: 'Unsupported browser',
            content: `This browser is not supported in USOSweb.
            In order to use the service, please download the current version of one of the browsers listed below”`
        }
    };
    const lang = document.documentElement.lang;
    const dict = translations[lang] || translations.pl;

    document.body.innerHTML =
        `<div class="usos-ui" style="margin: 5rem auto; max-width: max(20rem, 50vw);">
            <h1>${dict.h1}</h1>
            <p>${dict.content}:</p>
            <ul>
                <li><em><a href="https://www.mozilla.org/pl-PL/firefox/new/">Mozilla Firefox</a></em></li>
                <li><em><a href="https://www.google.com/chrome/">Google Chrome</a></em></li>
            </ul>
        </div>`;
}


window.addEventListener('DOMContentLoaded', function () {
    const requirements = [
        !!window.customElements,
        (function(){
            const script = document.createElement('script');
            return ('noModule' in script);
        })(),
        CSS.supports('color', 'var(--test)'),
        CSS.supports('selector(:is(div))'),
        (function(){
            const dialog = document.createElement('dialog');
            return !!window.HTMLDialogElement && typeof dialog.showModal === 'function';
        })(),
    ];

    const niceToHaves = [
        CSS.supports('grid-template-columns', 'subgrid'),
        CSS.supports('selector(:focus-within'),
        CSS.supports('selector(:focus-visible'),
        HTMLElement.prototype.hasOwnProperty('popover'),
    ];

    if (!requirements.every(Boolean)) {
        setUnsupportedMessage();
        return;
    }

    if (!niceToHaves.every(Boolean)) {
        console.warn('Ta przeglądarka mogłaby być nowsza');
        /* TODO: jak pojawi się snackbar lub coś podobnego,
            to pokazywać to w nowym komponencie */
    }

});
